import React from "react";
import { Empty } from "antd";
import { ReactComponent as CustomIcon } from "../../assets/images/emptyTable.svg";
import styled from "styled-components";
import { EmptyTableIcon } from "../Icons/EmptyTableIcon";

const EmptyCustom = styled(Empty)`
  & .ant-empty-description {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #818181;
  }
`;

const EmptyTableMobile = ({ T }) => {
  return (
    <div className="flex flex-col items-center">
      <EmptyTableIcon />
      <span className="text-center">{T("No records found.")}</span>
    </div>
  );
};
export default EmptyTableMobile;
